import { useState, useEffect } from "react";
import { DatePicker } from "../../components";

const Leading = ({
  createdFrom,
  createdTo,
  setCreatedFrom,
  setCreatedTo,
  summary,
  setSummary,
  setState,
  state,
}) => {
  const showActionMenu = (id) => {
    document.getElementById(id).classList.toggle("hidden");
  };

  // useEffect(() => {
  //   // setSummary(getObjectsInRange(createdFrom, createdTo, summary));
  // }, [createdFrom, createdTo]);

  function getObjectsInRange(startDate, endDate, data) {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    const output_obj = {};

    const response = {};

    for (const key in data) {
      if (typeof data[key] === "object") {
        const obj = data[key];
        const val = {};
        if (Object.keys(obj)?.length === 0) {
          output_obj[key] = {};
        }

        for (const date_key in obj) {
          let date_ = new Date(date_key).getTime();
          if (date_ >= startDate && date_ <= endDate) {
            val[date_key] = obj[date_key];
            output_obj[key] = val;
          } else {
            if (typeof output_obj[key] !== "object") {
              output_obj[key] = {};
            }
          }
        }
      }
    }
    response.summary = output_obj;
    return response;
  }

  return (
    <div>
      <div className="flex items-start justify-between mb-6">
        <div className="flex  w-full md:w-full flex-col md:flex-row items-start md:justify-between">
          <div className="pr-2">
            <h1 className="text-2xl leading-9 font-[600]">Dashboard</h1>
          </div>
          <div className=" w-full border rounded md:w-auto mt-2 md:mt-0">
            <DatePicker state={state} setState={setState} />
          </div>
        </div>

        {/* <div className="hidden md:flex items-center ">
          <div className="text-[#848484] md:text-sm text-xs mr-3">
            <p>Airtime Balance</p>
          </div>
          <div className="ml-4">
            <button className="bg-red-100 md:text-sm text-xs text-[#FF0000] font-semibold py-2 px-4 rounded-md">
              GHS 98,000.00
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Leading;
